import { render } from "./LoginAsDialog.vue?vue&type=template&id=cd3bacce&ts=true"
import script from "./LoginAsDialog.vue?vue&type=script&lang=ts"
export * from "./LoginAsDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__